import { CONFIGURACION_API_KEY_MODULE_ID } from './configuracionApiKeyModule'
import { CONFIGURACION_AUTOMATIZACIONES_MODULE_ID } from './configuracionAutomatizacionesModule'

export const CONFIGURACION_EQUIPO_MODULE_ID = 'configuracion_equipo'
export { CONFIGURACION_API_KEY_MODULE_ID, CONFIGURACION_AUTOMATIZACIONES_MODULE_ID }

/** No mostrar ni editar en permisos de empresa (solo usuario). */
export const USER_ONLY_MODULE_IDS = [
  CONFIGURACION_EQUIPO_MODULE_ID,
  CONFIGURACION_API_KEY_MODULE_ID,
  CONFIGURACION_AUTOMATIZACIONES_MODULE_ID,
]

export const ROLES_DEFAULT_CONFIGURACION_EQUIPO = [
  'ADMIN',
  'COLABORADOR',
  'SUPER_COLABORADOR',
  'DPO',
]

export function hasInternalTeamRole(roles) {
  return (roles || []).some((r) => ROLES_DEFAULT_CONFIGURACION_EQUIPO.includes(r))
}

export function defaultConfiguracionEquipoAccess(roles) {
  return hasInternalTeamRole(roles)
}
